var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#audience_svg__clip0_11181_130292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21.758c-4.2 0-7.617 3.417-7.617 7.617v4.688h15.234v-4.688c0-4.2-3.417-7.617-7.617-7.617z",
    fill: "url(#audience_svg__paint0_linear_11181_130292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.273 16.484A5.28 5.28 0 0020 11.211a5.28 5.28 0 00-5.273 5.273A5.28 5.28 0 0020 21.758a5.28 5.28 0 005.273-5.274z",
    fill: "url(#audience_svg__paint1_linear_11181_130292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.969 11.21a5.28 5.28 0 00-5.274-5.273 5.28 5.28 0 00-5.273 5.274 5.28 5.28 0 005.273 5.273 5.28 5.28 0 005.274-5.273z",
    fill: "url(#audience_svg__paint2_linear_11181_130292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.305 16.484c-3.096 0-5.755 1.864-6.945 4.522 2.759 1.773 4.6 4.853 4.6 8.369H40v-5.273c0-4.2-3.495-7.618-7.695-7.618z",
    fill: "url(#audience_svg__paint3_linear_11181_130292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.578 11.21a5.28 5.28 0 00-5.273-5.273 5.28 5.28 0 00-5.274 5.274 5.28 5.28 0 005.274 5.273 5.28 5.28 0 005.273-5.273z",
    fill: "url(#audience_svg__paint4_linear_11181_130292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.64 21.006c-1.19-2.658-3.849-4.522-6.945-4.522-4.2 0-7.695 3.417-7.695 7.618v5.273h10.04c0-3.516 1.841-6.596 4.6-8.37z",
    fill: "url(#audience_svg__paint5_linear_11181_130292)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint0_linear_11181_130292",
    x1: 20,
    y1: 21.758,
    x2: 20,
    y2: 34.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint1_linear_11181_130292",
    x1: 20,
    y1: 11.211,
    x2: 20,
    y2: 21.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint2_linear_11181_130292",
    x1: 7.695,
    y1: 5.938,
    x2: 7.695,
    y2: 16.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint3_linear_11181_130292",
    x1: 32.68,
    y1: 16.484,
    x2: 32.68,
    y2: 29.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint4_linear_11181_130292",
    x1: 32.305,
    y1: 5.938,
    x2: 32.305,
    y2: 16.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "audience_svg__paint5_linear_11181_130292",
    x1: 7.32,
    y1: 16.484,
    x2: 7.32,
    y2: 29.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38D15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "audience_svg__clip0_11181_130292"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/audience.3cea82c18041c09c0b32c1ffbe7b101a.svg";
export { SvgAudience as ReactComponent };